import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import { UserConsumer, UserContext } from '../../context/context';



function ComProfile() {
  const [state, actions] = useContext(UserContext);
  const [basicData, setBasicData] = useState()
  const [applyData, setApplyData] = useState()


//   console.log(state)

  const header = {Authorization: `JWT ${state.token}`}
  
  useEffect(()=>{
    async function fetchBasicData(){
      const res = await fetch(state.awslink + "/user/company/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{setBasicData(json)})
    }

    if(!basicData) fetchBasicData();
  })

//   const breakpoint = 768
  console.log(state, actions)

  console.log(basicData)

  return(
    <>
        {state.width < state.breakpoint ? 
            null
            :   
            <Wrapper>
                <MidWrapper>
                    <LeftWrapper>

                    </LeftWrapper>
                    <RightWrapper>

                    </RightWrapper>
                </MidWrapper>
            </Wrapper>   
        }
    </>
  )
}

export default ComProfile;

const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  height: 100%;
  justify-content: center;
  align-items: center;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`
const LeftWrapper = styled.div`
    display: flex;
    width: 29vw;
    margin-right: 1vw;
    height: 90%;
    border: red solid;
    background-color: white;
`
const RightWrapper = styled.div`
    display: flex;
    width: 69vw;
    margin-left: 1vw;
    height: 90%;
    border: red solid;
    background-color: white;
`